<template>
    <div class="editMember app-inner">
         <div class="public-btn-small flex align-cen posta enposta" style="padding-left:0;left:210px;width:calc(100% - 210px)">
            <div class="public-btn-small-plan"  @click="$util.reback('/teacheManage/member')" style="margin-left:0">
                返回
            </div>
             <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
             @click="onSubmit"
            >
                保存
            </el-button>
            </div>
             <div class="show_container">
                <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  权限设置
            </div>
        </div>
         <div class="appinfo">
            <div class="appname">电话号/账号：{{list.loginName || '-'}}</div>
            <div class="appname">
                <span >姓名：{{list.userName}}</span>
            </div>
            <div class="appname flex align-cen">
                    <div>权限设置/角色：</div>
                 <el-checkbox-group v-model="checkList">
                    <el-checkbox :label="item.roleId" v-for="(item,index) in list.roleList">{{item.roleName}}</el-checkbox>
                </el-checkbox-group>
            </div>
         </div>
             </div>
    </div>
</template>
<script>
import { getMemberDetail,teacherAuth} from "@/api/enterprise/index"; // 成员详情、设置成员角色
export default {
    name:'editMember',
    data() {
        return {
            loading:false,
            list:{},
            checkList:[]
        }
    },
    created () {
        this.getMeDetail()
    },
    methods: {
        // 获取成员详情
          getMeDetail(){
            this.checkList = []
        getMemberDetail({id:this.$route.query.id,businessId:this.$route.query.businessId},'enterprise')
            .then(res => {
            this.list = res.data || {}
            for (let i in res.data.roleList) {
                if(res.data.roleList[i].isRole == 1){
                    this.checkList.push(res.data.roleList[i].roleId)
                }
            }
            })
            .catch(err => {
            })
      },
        // 保存
        onSubmit(){
            let roleListArr = []
            for (let k in this.checkList) {
                roleListArr.push({
                    'roleId':this.checkList[k]
                })
            }
            let params = {
                id:this.$route.query.id,
                businessId:this.$route.query.businessId,
                roleList:roleListArr
            }
            this.loading = true
            teacherAuth(params,'enterprise')
            .then(res =>{
                this.loading = false
                if(res.code == 0){
                     this.$util.Notifi('设置成功','success','fa-check')
                     this.$util.reback('/teacheManage/member')
                }else{
                    this.$util.Notifi(res.msg,'error','fa-exclamation-circle')
                }
            })
            .catch(err =>{
                this.loading = false
                this.$util.Notifi('设置失败','error','fa-exclamation-circle')
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.editMember{
    margin-bottom: 50px;
    .appinfo{
        padding: 30px;
        .appname{
            padding-bottom: 10px;
            font-size: 16px;
        }
    }
    .team-tab{
        padding: 30px 0;
    }
}
</style>